import React from 'react'
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';
import {
    UiButton,
} from "../../../../../_uiComponents/common/form/UiButton";
import UiTableHead from '../../../../_uiComponents/UiTableHead';
import TablePagination from '@mui/material/TablePagination';
import Stack from '@mui/material/Stack';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


export default function ContentRevision(props) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(8);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState();


    const headings = [
        { id: 'version', name: 'Version' },
        { id: 'updatedBy', name: 'Updated By' },
        { id: 'updatedOn', name: 'Updated On' },
        { id: 'reason', name: 'Reason' },
       
        
        { id: '', name: '' }
    ]
    const rows = [
        {
            id: 1,
            version: '2000',
            reason: 'Mike',
            updatedOn: '2024-01-01',
            updatedBy: 'Mike',
           
        },
        {
            id: 2,
            version: '2000',
            reason: 'Mike',
            updatedOn: '2024-01-01',
            updatedBy: 'Mike',
        },
    ]
    //Sorting
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //Data sorting
    const sortingRows = React.useMemo(
        () =>
            stableSort(rows, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, rows],
    );


    return (
        <>
            <div className='sba-table-main-wr sba-campaign-content-table'>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650, mt: 0 }} aria-label="simple table" className='sbt-data-grid'>
                        <UiTableHead
                            headings={headings}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort} />
                        <TableBody>
                            {sortingRows.map((row, index) => (
                                <>

                                    <TableRow>
                                        <TableCell>
                                            {row.version}
                                        </TableCell>                                                                                                   
                                        <TableCell align="center">
                                            {row.updatedBy}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.updatedOn}
                                        </TableCell>     
                                        <TableCell align="center">
                                            {row.reason}
                                        </TableCell>
                                       
                                        <TableCell align="center">
                                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                                            <UiButton name="Load" variant="contained" size="small" color="primary" />
                                            <UiButton name="Publish" variant="contained" size="small" color="success"/>
                                        </Stack>
                                        </TableCell>
                                    </TableRow>
                                </>
                            ))}                       
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />



        </>
    )
}
